function NRFileBinaryIcon({ height = '20', width = '20', color = 'currentColor' }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 20 20" fill="none">
      <path d="M7.50016 17.5H5.8335V12.5H5.00016V10.8333H7.50016V17.5Z" fill={color} />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.6668 17.5H10.8335V10.8333H16.6668V17.5ZM12.5002 15.8333H15.0002V12.5H12.5002V15.8333Z"
        fill={color}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.16683 9.16667H3.3335V2.5H9.16683V9.16667ZM5.00016 7.5H7.50016V4.16667H5.00016V7.5Z"
        fill={color}
      />
      <path d="M15.0002 9.16667H13.3335V4.16667H12.5002V2.5H15.0002V9.16667Z" fill={color} />
    </svg>
  );
}
export default NRFileBinaryIcon;
